import React,{useEffect,useRef,useMemo} from "react";
import {SideBarNavigator as NativeComponent} from "vritra";
import ReactDOM from "react-dom/client";


export default function SideBarNavigator(props){
    const {entryId,fallbackEntryId,sidebarShown}=props;
    const state=useRef({
        ref:useRef(),
        element:null,
        sidebarShown:sidebarShown||true,
    }).current;
    const entries=useMemo(()=>mendEntries(props.entries),[props.entries]);
    useEffect(()=>{
        const {ref}=state;
        const parent=ref.current,{domref}=props;
        parent.innerHTML="";
        const element=state.element=NativeComponent({...props,parent,entries});
        if(typeof(domref)==="function"){domref(element)}
        else if(domref){domref.current=element};
        element.navigate(entryId);
    },[...statics.propkeys.map(key=>props[key]),entries]);
    useEffect(()=>{
        const {element}=state;
        const currentEntryId=element.getCurrentEntry()?.id;
        if(entryId!==currentEntryId){
            const didNavigate=element.navigate(entryId,false);
            if((!didNavigate)&&fallbackEntryId){
                element.navigate(fallbackEntryId,false);
            }
        };
        if(sidebarShown!==state.sidebarShown){
            state.sidebarShown=sidebarShown;
            setTimeout(()=>{element.toggleSideBar(sidebarShown)},200);
        }
    },[entryId,sidebarShown]);
    return React.createElement("div",{
        ref:state.ref,
        id:`sidebarnavigatorwrapper${props.id||""}`,
        key:`sidebarnavigatorwrapper${props.id||""}`,
        className:props.className,
        style:{display:"inline"},
    });
}
SideBarNavigator.defaultProps={
    entryId:null,
    sidebarShown:true,
}

const statics={
    propkeys:[
        "id","className","sidebarClassName","containerClassName",
        "sideBarScrollTheme",
        "tintColor","folderColor","endpointColor","style",
    ],
}

const mendEntries=(entries)=>entries.map(item=>{
    const entry={...item};
    const {entries}=entry;
    if(entries){entry.entries=mendEntries(entries)}
    else if(entry.renderContent){
        const {renderContent}=entry;
        entry.renderContent=({parent})=>{
            const wrapperEl=document.createElement("div");
            wrapperEl.style.display="inline";
            const root=ReactDOM.createRoot(wrapperEl);
            root.render(renderContent({}));
            parent.appendChild(wrapperEl);
            return wrapperEl;
        }
    }
    return entry;
});
